import { axios } from '~/libs/axios';
import { store } from '~/store';
import { accountActions } from '~/slices';

const login = async (
  message: string,
  walletAddress: string,
  signature: number[],
): Promise<{ accessToken: string; refreshToken: string }> => {
  const { data } = await axios.post<{
    accessToken: string;
    refreshToken: string;
  }>('/auth/login', {
    message,
    walletAddress,
    signature:
      '0x' +
      Array.from(signature, (b) => b.toString(16).padStart(2, '0')).join(''),
  });
  return data;
};

const refresh = async (
  refreshToken: string,
): Promise<{ accessToken: string; refreshToken: string }> => {
  const { data } = await axios.post<{
    accessToken: string;
    refreshToken: string;
  }>('/auth/refresh', { refreshToken });
  store.dispatch(
    accountActions.setAuthDate({
      accessToken: data.accessToken,
      refreshToken: data.refreshToken,
    }),
  );
  return data;
};

const logout = async (): Promise<void> => {
  await axios.post('/auth/logout');
};

export const authAPI = {
  login,
  refresh,
  logout,
};
